import { Languages } from 'lucide-react'
import { cn } from '../lib/utils'
import { useTexts } from './useTexts'

/**
 * Language choice in the sidebar. Languages are named in themselves (Deutsch, Italiano),
 * so the list is readable whatever language is active. Renders nothing while plato.HR
 * speaks only one language.
 */
export function LanguageSwitch({ collapsed }: { collapsed?: boolean }) {
    const { lang, setLang, languages } = useTexts()
    if (languages.length < 2) return null

    return (
        <div className={cn('flex items-center gap-1 border-t border-white/10 p-2', collapsed ? 'flex-col' : 'flex-row')}>
            {!collapsed && <Languages className="mx-2 h-4 w-4 shrink-0 text-white/50" aria-hidden="true" />}
            {languages.map((l) => (
                <button
                    key={l.lang}
                    type="button"
                    lang={l.lang}
                    aria-pressed={l.lang === lang}
                    title={l.name}
                    onClick={() => l.lang !== lang && void setLang(l.lang)}
                    className={cn(
                        'rounded-md px-2 py-1 text-xs transition-colors',
                        l.lang === lang ? 'bg-white/15 font-semibold text-white' : 'text-white/60 hover:bg-white/10 hover:text-white'
                    )}
                >
                    {collapsed ? l.lang.toUpperCase() : l.name}
                </button>
            ))}
        </div>
    )
}
